import { useMemo } from 'react';
import { EventStatus } from '@weave/schema-gen-ts/dist/schemas/schedule/v3/calendar_event.pb';
import { ScheduleQueries } from '@frontend/api-schedule';
import { SchedulerV3 } from '@frontend/api-schedule-v3';
import { ExtendedAppointment } from '@frontend/schedule-helpers';
import { APPT_STATUS_INFO_MAP } from '../../constants';
import { getIntegratedAppointmentStatusList } from './helpers';
import { AppointmentStatusType } from './types';

const APPT_STATUS_MENU_ITEMS = Object.entries(APPT_STATUS_INFO_MAP)
  .filter(([key]) => key !== EventStatus.UNKNOWN_EVENT_STATUS)
  .map(([key, info]) => ({
    key: key as EventStatus,
    value: key as EventStatus,
    label: info.label,
    icon: info.icon,
    variant: info.chipVariant,
  }));

type UseGetAppointmentStatusListParams = {
  isIntegrated?: boolean;
  appointmentDetails?: ExtendedAppointment;
};

export const useGetAppointmentStatusList = ({
  isIntegrated,
  appointmentDetails,
}: UseGetAppointmentStatusListParams): AppointmentStatusType[] => {
  const locationId = appointmentDetails?.locationId || '';

  const { data: sourceTenantsData, isLoading: isLoadingSourceTenantsData } =
    SchedulerV3.Queries.useListSourceTenantsQuery({
      request: { locationId },
      options: { enabled: !!locationId && isIntegrated },
    });

  const { data: appointmentStatusData, isLoading: isLoadingAppointmentStatusData } =
    ScheduleQueries.useGetAppointmentStatuses(locationId, !!locationId && isIntegrated);

  const appointmentStatusList = useMemo(() => {
    if (!isIntegrated) return APPT_STATUS_MENU_ITEMS;
    return getIntegratedAppointmentStatusList({
      appointmentDetails,
      appointmentStatusData,
      sourceTenants: sourceTenantsData?.sources,
    });
  }, [appointmentDetails, appointmentStatusData, isIntegrated, sourceTenantsData?.sources]);

  if (isLoadingSourceTenantsData || isLoadingAppointmentStatusData) {
    return [];
  }

  return appointmentStatusList;
};
